import { ratio } from '@opendevtools/wcag-color';
import { useMemo } from 'react';
import { isWhiteText } from '~/lib/Colors.js';

const CustomTag = ({ color, value, compact }) => {
    const backgroundColor = color || '#CCCCCC';
    const whiteText = useMemo(() => {
        if (!color) {
            return false;
        }

        return isWhiteText(color);
    }, [color]);

    return (
        <div
            className={`${compact ? 'px-1 py-0.5 text-[10px]' : 'px-3 py-1 text-sm'} rounded-full inline-block font-normal`}
            style={{
                backgroundColor: backgroundColor,
                color: whiteText ? '#FFFFFFBB' : '#00000099',
            }}
        >
            {value}
        </div>
    );
};

export default CustomTag;
